import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

function FormDatePicker({
  labelFormDatePicker,
  dateValue,
  onChangeDate,
  formSize,
  maxDate = moment(),
  // withMaxDate = false,
  ...props
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label={labelFormDatePicker}
        value={dateValue}
        onChange={onChangeDate}
        // maxDate={withMaxDate ? moment() : null}
        maxDate={maxDate}
        slotProps={{
          textField: { size: formSize ? formSize : "small", fullWidth: true },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
}

export default FormDatePicker;
